<template>
    <div>
        <div
            @click.stop="this.emitter.emit('toggleBasketPopover');"
            class="position-relative d-block nav-link basket-link cursor-pointer"
            :title="basketTitle"
        >
            <i
                :class="[basketIcon]"
            ></i>
            <div v-if="updatedBasket?.total_quantity > 0"
                class="basket-count rounded-5 position-absolute fw-bold"
            >
                {{ updatedBasket?.total_quantity }}
            </div>
        </div>
        <BasketPopover
            :basket="updatedBasket"
        ></BasketPopover>
    </div>

</template>

<script>
    import BasketPopover from '@shared/components/Basket/BasketPopover';

    export default {
        props: ['basket', 'icon'],
        components: {BasketPopover},
        data() {
            return {
                updatedBasket: this.basket
            }
        },
        mounted() {
            this.emitter.on('updateBasket', data => {
                this.updatedBasket = data;
            });
        },
        computed: {
            basketTitle() {
                if(this.updatedBasket?.products?.length > 0) {
                    return this.updatedBasket.products.length + ' item' + (this.updatedBasket.products.length == 1 ? '' : 's') + ' in basket';
                }
                else {
                    return 'No items in basket';
                }
            },
            basketIcon() {
                return this.icon ? this.icon : 'fa-regular fa-lg fa-basket-shopping';
            }
        }
    }
</script>

<style lang="scss" scoped>
    .basket-link {
        &:hover {
            text-decoration: none !important;
        }
    }
</style>